if (!customElements.get('cart-stock-check')) {
    class CartStockCheck extends ErpConnection {

        constructor() {
            super();
            
            this.messageQueue = new NotificationMessageQueue();
            
            this.validOrderId = true;
            
            this.handleValidOrderIdChange = this.handleValidOrderIdChange.bind(this);
            
            document.addEventListener('cart:rerendered', (e) => this.init());
            
            this.init();
        }
        
        init() {
            
            document.addEventListener('validOrderIdChange', this.handleValidOrderIdChange, false);
            
            this.stockErrors = false;
            this.stockMessages = [];
            
            this.i18n = document.querySelector('[data-cart-stock-check-i18n]');
            this.configuration = document.querySelector('[data-cart-stock-check-configuration]');
            
            try {
                this.i18n = JSON.parse(this.i18n.innerText);
                this.configuration = JSON.parse(this.configuration.innerText);
            } catch (err) {
                this.i18n = null;
                this.configuration = null;
            }
            
            if (this.configuration == null) { return; }
            
            this.submitButton = document.querySelector('button[type="submit"][name="checkout"]');
            
            if (this.configuration.gtc_check_enabled) {
                this.cart_gtc_check = document.getElementById('cart_gtc_check');
                if (this.cart_gtc_check) {
                    this.cart_gtc_check.addEventListener('click', this.checkGtc.bind(this));
                }
            }
            
            this.run()
                .then(() => {
                    this.finishCheck();
                });
        }
        
        async fetchAll(requestData) {
            const response      = await Promise.all(requestData.map(data => fetch(data.url, { method: "GET", headers: this.HEADER.GET })));
            const responseJson  = await Promise.all(response.map(data => data.json()));
            return responseJson.map((response, index) => { return { response: response, product: requestData[index].product } });
        }

        run() {

            return new Promise(resolve => {
                
                let requestData = this.configuration.products.map(product => {
                    return {
                        url: this.ENDPOINT + "/stock?" + new URLSearchParams({
                            item_id: product.item_id,
                            company: product.company
                        }),
                        product: product
                    }
                });
                
                this.fetchAll(requestData)
                    .then(json => {
                        this.stockMessages = [];
                        json.forEach(productResult => {
                            if (productResult.response.amount != undefined && productResult.response.amount != null) {
                                let amount = parseInt(productResult.response.amount);
                                if (amount == 0 || productResult.product.quantity > amount) {
                                    this.stockMessages.push(this.i18n.out_of_stock + ": " + productResult.product.title);
                                    this.stockErrors = true;
                                }
                            } else {
                                this.stockErrors = true;
                            }
                        });
                        resolve();
                    });
            });
        }
        
        finishCheck() {
            
            this.messageQueue.clearForcedMessages();
            
            if (this.stockErrors) {
                this.stockMessages.forEach(message => this.messageQueue.forceDisplay(message));
            }
            
            if (this.stockErrors == false && this.configuration.gtc_check_enabled == false) {
                this.submitButton.disabled = false;
            }
        }
        
        handleValidOrderIdChange(e) {
            let updateSubmitButton = (this.validOrderId != e.detail);
            this.validOrderId = e.detail;
            updateSubmitButton && this.checkGtc();
        }
        
        checkGtc(event) {
            this.submitButton.disabled = 
                !(this.validOrderId && !this.configuration.stock_check_enabled && this.cart_gtc_check.checked) && 
                !(this.validOrderId && this.configuration.stock_check_enabled && !this.stockErrors && this.cart_gtc_check.checked);
        }
    }
    
    customElements.define('cart-stock-check', CartStockCheck);
}